<div class="container-capped-sm py-3 px-2 kp-spinner-container-lg">
  <ngx-spinner name="loading" [fullScreen]="false" type="timer"></ngx-spinner>
  <div class="py-3" *ngIf="!user">
    <app-login [inline]="true"> </app-login>
  </div>
  <ng-container *ngIf="user">
    <h3>{{user.Name}} عزیز، خوش آمدید.</h3>
    <ng-container *ngIf="!user.Seeker?.IsAcceptable">
      <div class="kp-card bg-cover d-flex align-items-end pt-5 pointer mx-0" routerLink="/seeker/matching"
        style="background-image: url(/assets/images/seeker/vanguard/card-bg.svg);background-position: left;">
        <div class="p-2">
          <h6 class="">خودت رو به کارفرماها نشون بده</h6>
          <div class="fs-xl font-weight-bold">
            <div class="btn btn-primary">رزومه‌ات رو ثبت کن</div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!user.Seeker?.JobAlertSettings?.IsSubscribed">
      <div class="kp-card bg-cover d-flex align-items-end pt-5 pointer mx-0" routerLink="/seeker/matching"
        style="background-image: url(/assets/images/seeker/profile/card-job-alert.svg);">
        <div class="p-2">
          <h6 class="">شغلی که دنبالشی رو به ما بگو</h6>
          <div class="fs-xl font-weight-bold">
            <div>گوش به زنگ</div>
            <div>تازه‌ترین فرصت‌ها باش</div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="user.Seeker?.JobAlertSettings?.IsSubscribed">
      <div class="kp-card bg-cover d-flex align-items-end pt-5 pointer" routerLink="/seeker/matching"
        
        style="background-image: url(/assets/images/seeker/profile/card-job-alert.svg);">
        <div class="p-2">
          <h6 class="">شغل جدیدت رو پیدا کن</h6>
          <div class="fs-xl font-weight-bold">
            <div>آگهی‌هایی که برات پیدا کردیم رو ببین</div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="user.Seeker?.IsAcceptable && !user.Seeker?.PromoteUntilDays">
      <div class="kp-card bg-cover f-white d-flex flex-column"
        style="background-image: url(/assets/images/seeker/profile/card-matching.svg);">
        <div class="p-2">
          <h6 class="mb-3">شغل‌های مناسب رو روی گوشیت دریافت کن</h6>
          <div class="fs-sm mb-2">
            این آگهی‌ها رو هر روز از طریق پیامک دریافت می‌کنی
          </div>
          <div class="text-center align-self-end px-3">
            <div class="btn btn-primary w-100" routerLink="/seeker/matching">
              <i class="fa fa-bullhorn ml-2"></i> کارجوی پیشتاز شو
            </div>
          </div>
        </div>
      </div>
    </ng-container>


  </ng-container>
  <div dir="ltr" class="text-left overflow-auto" >
    <div  (click)="showLog=!showLog">&nbsp;</div>
    <pre  style="max-height: 300px;" *ngIf="showLog">
      {{log | json}}
    </pre>
  </div>

</div>